import React, {useEffect, useState} from "react";
import {TextScene} from "../../common/text";

const EMOJI = {1: '😅', 3: '😰'};
const PERFORMANCE_LABELS = {1: 'Your Drawing', 3: 'Your Dance'};

export const DancelestrationsScores = ({isControl, round}) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (isControl) return;
        let live = true;
        const tick = () => fetch(`/dancelestrations/scores?round=${round}`, {credentials: 'include'})
            .then(r => r.json())
            .then(d => { if (live) setData(d); })
            .catch(() => {});
        tick();
        const id = setInterval(tick, 1500);
        return () => { live = false; clearInterval(id); };
    }, [isControl, round]);

    if (isControl) return <TextScene isControl text={EMOJI[round]}/>;
    if (!data) return null;
    return <ScoresPlayer data={data} round={round}/>;
};

const label = {fontSize: 14, fontWeight: 800, letterSpacing: 4, textTransform: 'uppercase', opacity: 0.65};
const value = {fontSize: 28, fontWeight: 800, lineHeight: 1.25, margin: '4px 0 18px'};
const scoreStyle = {fontSize: 52, fontWeight: 900, color: '#f1d28b', textShadow: '0 0 18px rgba(232,177,90,0.6)'};
const reactionStyle = {fontSize: 22, fontWeight: 700, fontStyle: 'italic', marginTop: 6};
const judging = {fontSize: 20, opacity: 0.7, marginTop: 6};

const ScoresPlayer = ({data, round}) => {
    const you = data.you || {};
    const guesser = you.as_guesser;
    const performer = you.as_performer;

    return <div style={{
        width: '100%',
        minHeight: '100dvh',
        boxSizing: 'border-box',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '24px',
    }}>
        {!guesser && <div style={value}>No guess made.</div>}
        {guesser && <>
            <div style={label}>Your Guess:</div>
            <div style={value}>"{guesser.guess}"</div>
            <div style={label}>It Was:</div>
            <div style={value}>"{guesser.source_word}"</div>
            {guesser.score === null
                ? <div style={judging}>Still Judging...</div>
                : <>
                    <div style={scoreStyle}>+{guesser.score}</div>
                    <div style={reactionStyle}>{guesser.reaction}</div>
                </>}
        </>}

        <div style={{width: '60%', borderTop: '1px solid rgba(255,255,255,0.25)', margin: '32px 0'}}/>

        {!performer && <div style={value}>Nobody guessed on yours.</div>}
        {performer && <>
            <div style={label}>{PERFORMANCE_LABELS[round]}:</div>
            <div style={value}>"{performer.source_word}"</div>
            <div style={label}>Guessed As:</div>
            <div style={value}>"{performer.guessed_as}"</div>
            {performer.score === null
                ? <div style={judging}>Still Judging...</div>
                : <>
                    <div style={scoreStyle}>+{performer.score}</div>
                    <div style={reactionStyle}>{performer.reaction}</div>
                </>}
        </>}
    </div>;
};
